module.exports = __webpack_public_path__ + "media/images/login/ic_bg_img-016ca6c204acb30c6c22efd658f348e3.png";